import { render, staticRenderFns } from "./bookingactionbutton.vue?vue&type=template&id=5a23014e&"
import script from "./bookingactionbutton.vue?vue&type=script&lang=js&"
export * from "./bookingactionbutton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports